const __WEBPACK_NAMESPACE_OBJECT__ = window["bonnet-webcomponent-react-redux"];